import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProfilePhotoUpload = ({ value, onChange, error }) => {
  const [preview, setPreview] = useState(value || null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      // Validate file type
      if (!file?.type?.startsWith('image/')) {
        return;
      }

      // Validate file size (max 5MB)
      if (file?.size > 5 * 1024 * 1024) {
        return;
      }

      setIsUploading(true);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageUrl = e?.target?.result;
        setPreview(imageUrl);
        onChange(imageUrl);
        setIsUploading(false);
      };
      reader?.readAsDataURL(file);
    }
  };

  const handleRemovePhoto = () => {
    setPreview(null);
    onChange(null);
    if (fileInputRef?.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUploadClick = () => {
    fileInputRef?.current?.click();
  };

  return (
    <div className="space-y-4">
      <label className="block text-sm font-medium text-foreground">
        تصویر پروفایل
      </label>
      
      <div className="flex flex-col items-center space-y-4">
        {/* Photo Preview */}
        <div className="relative">
          <div className="w-32 h-32 rounded-full border-2 border-border overflow-hidden bg-muted flex items-center justify-center">
            {preview ? (
              <Image
                src={preview}
                alt="تصویر پروفایل"
                className="w-full h-full object-cover"
              />
            ) : (
              <Icon name="User" size={48} className="text-muted-foreground" />
            )}
          </div>
          
          {preview && (
            <button
              onClick={handleRemovePhoto}
              className="absolute -top-2 -left-2 w-8 h-8 bg-destructive text-destructive-foreground rounded-full flex items-center justify-center hover:bg-destructive/90 transition-smooth focus-ring"
            >
              <Icon name="X" size={16} />
            </button>
          )}
        </div>

        {/* Upload Controls */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            onClick={handleUploadClick}
            loading={isUploading}
            iconName="Upload"
            iconPosition="right"
          >
            {preview ? 'تغییر تصویر' : 'انتخاب تصویر'}
          </Button>
          
          {preview && (
            <Button
              variant="ghost"
              onClick={handleRemovePhoto}
              iconName="Trash2"
              iconPosition="right"
            >
              حذف تصویر
            </Button>
          )}
        </div>

        {/* File Input */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          className="hidden"
        />

        {/* Guidelines */}
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            فرمت‌های مجاز: JPG, PNG, GIF
          </p>
          <p className="text-xs text-muted-foreground">
            حداکثر حجم: ۵ مگابایت
          </p>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <p className="text-sm text-destructive flex items-center">
          <Icon name="AlertCircle" size={16} className="ml-2" />
          {error}
        </p>
      )}
    </div>
  );
};

export default ProfilePhotoUpload;